import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { customTheme } from '@ipen-portal/plugin-common-react';

export const EonTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'eon-theme',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={customTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
      title: 'EON Theme',
      variant: 'light',
    },
  },
});
